import { render, staticRenderFns } from "./SimularTrabajos.vue?vue&type=template&id=dbf38a22&scoped=true"
import script from "./SimularTrabajos.vue?vue&type=script&lang=js"
export * from "./SimularTrabajos.vue?vue&type=script&lang=js"
import style0 from "./SimularTrabajos.vue?vue&type=style&index=0&id=dbf38a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf38a22",
  null
  
)

export default component.exports